export const DATASET_STREAM_MAX_RETRIES = 3;

export class CustomError<T = unknown, R = string> extends Error {
  code: number;
  message: string;
  details?: T;
  reason?: R;

  constructor(message: string, code: number, details?: T, reason?: NoInfer<R>) {
    super(message);
    this.code = code;
    this.message = message;
    this.details = details;
    this.reason = reason;
  }
}

export class UnauthorizedStreamError extends Error {
  constructor() {
    super("Unauthorized");
    this.name = "UnauthorizedStreamError";
  }
}
